query getContent($id: Int, $type: String, $title: String) {
  propsContent(id: $id, type: $type, title: $title, activatedOrFinishedProgram: false) {
    id
    props
    images {
      id
      compressedImage {
        webp {
          lg
          md
          sm
          xl
          xs
        }
      }
    }
  }
}
